import { isNonEmptyString } from './helpers';

export type SignType = '' | 'plus' | 'minus';

export const matchDateCondition = (source: string): RegExpMatchArray => isNonEmptyString(source)
  ? source.match(/^calc-date:(now|birthday)(-(plus|minus)-(\d+)-(days|months|years))?/)
  : null;
